// extracted by mini-css-extract-plugin
export var name = "Review-module--name--70f49";
export var review = "Review-module--review--eec1c";
export var title = "Review-module--title--9a9f3";